import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import {
  SubscriberState,
  SubscriberParams,
  SubscriberApiResponse,
  SubscPageParams,
  MonthWeekSubscApiResponse,
  MonthAgeSubscApiResponse,
  SubscPerDayApiResponse,
} from "./SubscriberType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

//情報取得API連携
export const fetchAsyncSubscriber: any = createAsyncThunk<
  SubscriberParams,
  SubscriberApiResponse
>("Subscriber/get", async () => {
  const response = await axiosSettings.get("api-admin/user/subscriber");
  return response.data;
});

//月ごとの週別登録者数
export const fetchAsyncSubscMonthWeek: any = createAsyncThunk<
  MonthWeekSubscApiResponse & { page: number },
  SubscPageParams
>("SubscMonthWeek/get", async (page) => {
  const response = await axiosSettings.get(
    `api-admin/user/subsc-month-week?page=${page}`
  );

  return response.data;
});

//月ごとの年齢別登録者数
export const fetchAsyncSubscMonthAge: any = createAsyncThunk<
  MonthAgeSubscApiResponse,
  SubscPageParams
>("SubscMontHAge/get", async (page) => {
  const response = await axiosSettings.get(
    `api-admin/user/subsc-month-age?page=${page}`
  );
  return response.data;
});

//直近7日間の登録者数
export const fetchAsyncSubscPerDay: any = createAsyncThunk<
  SubscPerDayApiResponse,
  SubscPageParams
>("SubscPerDay/get", async (page) => {
  const response = await axiosSettings.get(
    `api-admin/user/subsc-per-day?page=${page}`
  );
  return { ...response.data, page };
});

const initialState: SubscriberState = {
  subscriber: null,
  subscMonthWeek: null,
  subscMonthAge: null,
  subscPerDay: null,
  updatedTime: "",
  loading: false,
  error: "",
};

const SubscriberSlice = createSlice({
  name: "Subscriber",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    //登録者数
    builder.addCase(fetchAsyncSubscriber.fulfilled, (state, action) => {
      if (action.payload.status === "Success") {
        state.subscriber = action.payload.data.result;
        state.updatedTime = GetTime();
        state.error = "";
      } else {
        state.error = action.payload.data;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncSubscriber.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncSubscriber.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.data.result || "Failed to fetch users";
    });
    //月ごとの週ごとの登録者数
    builder.addCase(fetchAsyncSubscMonthWeek.fulfilled, (state, action) => {
      state.subscMonthWeek = action.payload.data.result;
      state.error = "";
      state.loading = false;
    });
    builder.addCase(fetchAsyncSubscMonthWeek.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncSubscMonthWeek.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.data.result || "Failed to fetch users";
    });
    //月ごとの年齢ごとの登録者数
    builder.addCase(fetchAsyncSubscMonthAge.fulfilled, (state, action) => {
      state.subscMonthAge = action.payload.data.result;
      state.error = "";
      state.loading = false;
    });
    builder.addCase(fetchAsyncSubscMonthAge.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncSubscMonthAge.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.data.result || "Failed to fetch users";
    });
    //直近7日間の登録者数
    builder.addCase(fetchAsyncSubscPerDay.fulfilled, (state, action) => {
      state.subscPerDay = action.payload.data.result;
      state.error = "";
      state.loading = false;
    });
    builder.addCase(fetchAsyncSubscPerDay.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAsyncSubscPerDay.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.data.result || "Failed to fetch users";
    });
  },
});

export const SubscriberInfo = (state: RootState) => state.Subscriber.subscriber;
export const SubscMonthWeek = (state: RootState) =>
  state.Subscriber.subscMonthWeek;
export const SubscMonthAge = (state: RootState) =>
  state.Subscriber.subscMonthAge;
export const SubscPerDay = (state: RootState) => state.Subscriber.subscPerDay;
export const SubscriberError = (state: RootState) => state.Subscriber.error;
export const SubscriberLoading = (state: RootState) => state.Subscriber.loading;
export const SubscriberUpdatedTime = (state: RootState) =>
  state.Subscriber.updatedTime;
export default SubscriberSlice.reducer;
